var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonCreateVariant/ButtonCreateVariants.tsx",
  _this = this;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { createURL } from '@sm/utils';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { IconChevronLeft } from '@wds/icons';
import { t, T } from '@sm/intl';
import { List } from '@wds/list';
import { Grid } from '@wds/grid';
import { generateMetricsAttribute } from '@sm/metrics';
import audienceImage from './images/audience.svg';
import copyPasteImage from './images/copy-paste.svg';
import createFromScratchImage from './images/create-scratch.svg';
import guidanceImage from './images/bifm.svg';
import guidedSetupImage from './images/guided-setup.svg';
import solutionImage from './images/solution.svg';
import templateImage from './images/template.svg';
import { ClickMetricEventName, isClickMenuItem, isHrefMenuItem, View } from './types';
export var COPY = {
  startingPoint: {
    id: 'ButtonCreateVariant.startingPoint',
    defaultMessage: 'Choose a starting point...',
    description: '[Type: Header][Vis.: high] - Heading for sidebar drawer menu for creating a survey'
  },
  guidedSetup: {
    id: 'ButtonCreateVariant.guidedSetup',
    defaultMessage: 'Guided setup',
    description: '[Type: Header][Vis.: high] - Heading for sidebar drawer menu for using our solutions products'
  },
  goBackToStartingPoint: {
    id: 'ButtonCreateVariant.goBackToStartingPoint',
    defaultMessage: 'Go back to "Choose a starting point"',
    description: '[Type: Label][Vis.: high] - Label used exclusively for screen readers for going back in a menu'
  },
  startWithBlank: {
    id: 'ButtonCreateVariant.startWithBlank',
    defaultMessage: 'Start with a blank survey',
    description: '[Type: Label][Vis.: high] - Title for a link to survey creation, starting from scratch'
  },
  startWithBlankDesc: {
    id: 'ButtonCreateVariant.startWithBlankDesc',
    defaultMessage: 'Best for experienced survey authors',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to survey creation, starting from scratch'
  },
  startWithBlankVariantDesc: {
    id: 'ButtonCreateVariant.startWithBlankVariantDesc',
    defaultMessage: 'Good for those who want to start from scratch or copy and paste',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to survey creation, starting from scratch -- variant copy'
  },
  copyPaste: {
    id: 'ButtonCreateVariant.copyPaste',
    defaultMessage: 'Copy and paste from doc',
    description: '[Type: Label][Vis.: high] - Title for a link to survey creation, starting with copy/paste'
  },
  copyPasteDesc: {
    id: 'ButtonCreateVariant.copyPasteDesc',
    defaultMessage: 'Great for anyone who wants to import prewritten questions',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to survey creation, starting with copy/paste'
  },
  guidedSetupMenuItem: {
    id: 'ButtonCreateVariant.guidedSetupMenuItem',
    defaultMessage: 'Try guided setup',
    description: '[Type: Label][Vis.: high] - Title for a button that opens a sub-menu detailing our marketing solutions'
  },
  guidedSetupMenuItemDesc: {
    id: 'ButtonCreateVariant.guidedSetupMenuItemDesc',
    defaultMessage: 'Helpful for those who want guidance, templates or brand/marketing insights',
    description: '[Type: Paragraph][Vis.: high] - Description for a button that opens a sub-menu detailing our marketing solutions'
  },
  guidedSetupVariantDesc: {
    id: 'ButtonCreateVariant.guidedSetupVariantDesc',
    defaultMessage: 'Helpful for people who like step-by-step guidance',
    description: '[Type: Paragraph][Vis.: high] - Description for a button that opens create with "build it for me" auto-opened'
  },
  buyResponses: {
    id: 'ButtonCreateVariant.buyResponses',
    defaultMessage: 'Buy targeted responses',
    description: '[Type: Label][Vis.: high] - Title for a link to Audience preview'
  },
  buyResponsesDesc: {
    id: 'ButtonCreateVariant.buyResponsesDesc',
    defaultMessage: 'Excellent for people who want to start by choosing audience demographics',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  insightsSolutions: {
    id: 'ButtonCreateVariant.insightsSolutions',
    defaultMessage: 'Insights solutions',
    description: '[Type: Label][Vis.: high] - Title for a link to Audience preview'
  },
  insightsSolutionsVariant: {
    id: 'ButtonCreateVariant.insightsSolutionsVariant',
    defaultMessage: 'Do brand or market research',
    description: '[Type: Label][Vis.: high] - Title for a link to the solutions marketplace launchpad'
  },
  insightsSolutionsVariantDesc: {
    id: 'ButtonCreateVariant.insightsSolutionsVariantDesc',
    defaultMessage: 'Useful for those who want to test an idea or track a brand/market',
    description: '[Type: Paragraph][Vis.: high] - Description for a button that links to the solutions marketplace launchpad'
  },
  insightsSolutionsDesc: {
    id: 'ButtonCreateVariant.insightsSolutionsDesc',
    defaultMessage: 'Get an AI-backed solution like...',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  brandTracking: {
    id: 'ButtonCreateVariant.brandTracking',
    defaultMessage: 'Brand tracking',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  conceptTesting: {
    id: 'ButtonCreateVariant.conceptTesting',
    defaultMessage: 'Concept testing',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  ideaScreening: {
    id: 'ButtonCreateVariant.ideaScreening',
    defaultMessage: 'Idea screening',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  muchMore: {
    id: 'ButtonCreateVariant.muchMore',
    defaultMessage: 'Much more',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  productGuidance: {
    id: 'ButtonCreateVariant.productGuidance',
    defaultMessage: 'In-product guidance',
    description: '[Type: Label][Vis.: high] - Title for a link to Audience preview'
  },
  productGuidanceDesc: {
    id: 'ButtonCreateVariant.productGuidanceDesc',
    defaultMessage: 'Let SurveyMonkey help via...',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  stepByStep: {
    id: 'ButtonCreateVariant.stepByStep',
    defaultMessage: 'Step-by-step instructions',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  standardSurveys: {
    id: 'ButtonCreateVariant.standardSurveys',
    defaultMessage: 'Standard surveys',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  featureExplanations: {
    id: 'ButtonCreateVariant.featureExplanations',
    defaultMessage: 'Feature explanations',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  customizationTips: {
    id: 'ButtonCreateVariant.customizationTips',
    defaultMessage: 'Customization tips',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  popularTemplate: {
    id: 'ButtonCreateVariant.popularTemplate',
    defaultMessage: 'Popular template',
    description: '[Type: Label][Vis.: high] - Title for a link to Audience preview'
  },
  popularTemplateDesc: {
    id: 'ButtonCreateVariant.popularTemplateDesc',
    defaultMessage: 'Pick from templates like...',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  popularTemplateVariant: {
    id: 'ButtonCreateVariant.popularTemplateVariant',
    defaultMessage: 'Pick a popular template',
    description: '[Type: Label][Vis.: high] - Title for a link to survey creation with templates auto-opened'
  },
  popularTemplateVariantDesc: {
    id: 'ButtonCreateVariant.popularTemplateVariantDesc',
    defaultMessage: 'Good for anyone who wants to ask common questions',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to survey creation with templates auto-opened'
  },
  customerSatisfaction: {
    id: 'ButtonCreateVariant.customerSatisfaction',
    defaultMessage: 'Customer satisfaction',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  employeeEngagement: {
    id: 'ButtonCreateVariant.employeeEngagement',
    defaultMessage: 'Employee engagement',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  netPromoterScore: {
    id: 'ButtonCreateVariant.netPromoterScore',
    defaultMessage: 'Net promoter score',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  },
  manyOthers: {
    id: 'ButtonCreateVariant.manyOthers',
    defaultMessage: 'Many others',
    description: '[Type: Paragraph][Vis.: high] - Description for a link to Audience preview'
  }
};
var convertToMenuItem = function convertToMenuItem(viewListItem, clickHandler) {
  var _viewListItem$navigat;
  if (!viewListItem.navigationTarget && clickHandler) {
    return _objectSpread(_objectSpread({}, viewListItem), {}, {
      onClick: clickHandler
    });
  }
  return _objectSpread(_objectSpread({}, viewListItem), {}, {
    href: (_viewListItem$navigat = viewListItem.navigationTarget) !== null && _viewListItem$navigat !== void 0 ? _viewListItem$navigat : ''
  });
};
var startFromScratch = {
  eventName: ClickMetricEventName.StartFromScratch,
  title: t(COPY.startWithBlank),
  iconSrc: createFromScratchImage,
  navigationTarget: createURL('/create/', {
    ut_source: 'header',
    create: 'scratch'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 271,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.startWithBlankDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 272,
      columnNumber: 7
    }
  }))
};
var startFromScratchVariant = {
  eventName: ClickMetricEventName.StartFromScratch,
  title: t(COPY.startWithBlank),
  iconSrc: createFromScratchImage,
  navigationTarget: createURL('/create/', {
    ut_source: 'header',
    create: 'scratch'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 286,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.startWithBlankVariantDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 287,
      columnNumber: 7
    }
  }))
};
var copyAndPaste = {
  eventName: ClickMetricEventName.CopyAndPaste,
  title: t(COPY.copyPaste),
  iconSrc: copyPasteImage,
  navigationTarget: createURL('/create/', {
    ut_source: 'header',
    create: 'importQuestions'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 301,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.copyPasteDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 302,
      columnNumber: 7
    }
  }))
};
var seeGuidedSetupOptions = {
  title: t(COPY.guidedSetupMenuItem),
  iconSrc: guidedSetupImage,
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 311,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.guidedSetupMenuItemDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 312,
      columnNumber: 7
    }
  }))
};
var buyResponses = {
  eventName: ClickMetricEventName.Audience,
  title: t(COPY.buyResponses),
  iconSrc: audienceImage,
  navigationTarget: createURL('/collect/audience/calculator/preview/', {
    ut_source: 'header'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 325,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.buyResponsesDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 326,
      columnNumber: 7
    }
  }))
};
var solutions = {
  eventName: ClickMetricEventName.Solution,
  title: t(COPY.insightsSolutions),
  iconSrc: solutionImage,
  navigationTarget: createURL('/market-research/solutions/get-started/', {
    ut_source: 'header'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 339,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.insightsSolutionsDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 340,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("ul", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 341,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 342,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.brandTracking,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 343,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 345,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.conceptTesting,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 346,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 348,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.ideaScreening,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 349,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 351,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.muchMore,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 352,
      columnNumber: 11
    }
  }))))
};
var solutionsVariant = {
  eventName: ClickMetricEventName.Solution,
  title: t(COPY.insightsSolutionsVariant),
  iconSrc: solutionImage,
  navigationTarget: createURL('/market-research/solutions/get-started/', {
    ut_source: 'header'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 367,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.insightsSolutionsVariantDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 368,
      columnNumber: 7
    }
  }))
};
var buildItForMe = {
  eventName: ClickMetricEventName.BuildItForMe,
  title: t(COPY.productGuidance),
  iconSrc: guidanceImage,
  navigationTarget: createURL('/create/', {
    ut_source: 'header',
    create: 'bifm'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 382,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.productGuidanceDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 383,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("ul", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 384,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 385,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.stepByStep,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 386,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 388,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.standardSurveys,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 389,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 391,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.featureExplanations,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 392,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 394,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.customizationTips,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 395,
      columnNumber: 11
    }
  }))))
};
var buildItForMeVariant = {
  eventName: ClickMetricEventName.BuildItForMe,
  title: t(COPY.guidedSetupMenuItem),
  iconSrc: guidanceImage,
  navigationTarget: createURL('/create/', {
    ut_source: 'header',
    create: 'bifm'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 411,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.guidedSetupVariantDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 412,
      columnNumber: 7
    }
  }))
};
var templates = {
  eventName: ClickMetricEventName.Template,
  title: t(COPY.popularTemplate),
  iconSrc: templateImage,
  navigationTarget: createURL('/create/', {
    ut_source: 'header',
    create: 'template'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 426,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.popularTemplateDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 427,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("ul", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 428,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 429,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.customerSatisfaction,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 430,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 432,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.employeeEngagement,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 433,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 435,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.netPromoterScore,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 436,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("li", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 438,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.manyOthers,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 439,
      columnNumber: 11
    }
  }))))
};
var templatesVariant = {
  eventName: ClickMetricEventName.Template,
  title: t(COPY.popularTemplateVariant),
  iconSrc: templateImage,
  navigationTarget: createURL('/create/', {
    ut_source: 'header',
    create: 'template'
  }),
  bodyContent: /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 455,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.popularTemplateVariantDesc,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 456,
      columnNumber: 7
    }
  }))
};
var useStyles = createUseStyles(function (theme) {
  return {
    listItemContent: {
      whiteSpace: 'break-spaces',
      marginTop: "".concat(theme.spacing[1], "px")
    },
    sheetTitle: {
      margin: "".concat(theme.spacing[5], "px 0 ").concat(theme.spacing[5], "px ").concat(theme.spacing[4], "px")
    },
    bolded: {
      fontWeight: 400,
      color: theme.palette.text.dark
    },
    listItem: {
      padding: "".concat(theme.spacing[4], "px 0 ").concat(theme.spacing[4], "px 0")
    },
    listLink: {
      display: 'block',
      borderBottom: "solid thin ".concat(theme.palette.border.main),
      '&:last-child': {
        borderBottom: 'none'
      },
      '&:hover,:focus': {
        textDecoration: 'none'
      }
    },
    listItemTitle: {
      fontSize: '16px'
    },
    backButton: {
      textDecoration: 'none',
      border: 'none',
      background: 'transparent',
      '&:hover': {
        cursor: 'pointer',
        background: theme.palette.background.accent
      }
    },
    backButtonIcon: {
      display: 'flex',
      alignItems: 'center',
      marginRight: "".concat(theme.spacing[2], "px"),
      color: theme.palette.text.darkMuted,
      fontSize: '20px'
    },
    iconImageContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: '100%',
      '& img': {
        height: '48px',
        width: '48px'
      }
    }
  };
});
var ListItem = function ListItem(_ref) {
  var listItem = _ref.listItem,
    pageName = _ref.pageName;
  var _useStyles = useStyles(),
    listItemClass = _useStyles.listItem,
    listLinkClass = _useStyles.listLink,
    listItemContent = _useStyles.listItemContent,
    listItemTitle = _useStyles.listItemTitle,
    iconImageContainer = _useStyles.iconImageContainer;
  var isButton = isClickMenuItem(listItem);
  var inner = /*#__PURE__*/React.createElement("div", {
    className: listItemClass,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 534,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    noBleeds: true,
    noGutters: true,
    fluid: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 535,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    xs: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 536,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: iconImageContainer,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 537,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: listItem.iconSrc,
    alt: "",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 538,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement(Grid.Item, {
    xs: 10,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 541,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 542,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("strong", {
    className: listItemTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 548,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("strong", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 549,
      columnNumber: 15
    }
  }, listItem.title)), /*#__PURE__*/React.createElement("div", {
    className: listItemContent,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 551,
      columnNumber: 13
    }
  }, listItem.bodyContent)))));
  if (isButton) {
    return /*#__PURE__*/React.createElement(List.Item, {
      interactive: true,
      onClick: isClickMenuItem(listItem) ? listItem.onClick : undefined,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 560,
        columnNumber: 7
      }
    }, inner);
  }
  return /*#__PURE__*/React.createElement("a", {
    className: listLinkClass,
    href: isHrefMenuItem(listItem) ? listItem.href : undefined,
    target: "_blank",
    rel: "noreferrer noopener",
    "data-sm-metrics": isHrefMenuItem(listItem) && listItem.eventName ? generateMetricsAttribute({
      data: {
        pageName: pageName,
        amplitudeEvent: 'create menu clicked option',
        ctaName: listItem.eventName
      }
    }) : undefined,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 570,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(List.Item, {
    interactive: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 587,
      columnNumber: 7
    }
  }, inner));
};
export var DrillDownMenuVariant = function DrillDownMenuVariant(_ref2) {
  var view = _ref2.view,
    setView = _ref2.setView,
    pageName = _ref2.pageName;
  var _useStyles2 = useStyles(),
    sheetTitle = _useStyles2.sheetTitle,
    backButton = _useStyles2.backButton,
    backButtonIcon = _useStyles2.backButtonIcon,
    bolded = _useStyles2.bolded;
  var startingPointMenuItems = [startFromScratch, copyAndPaste, seeGuidedSetupOptions, buyResponses].map(function (viewListItem) {
    return convertToMenuItem(viewListItem, function () {
      return setView(View.GuidedSetup);
    });
  });
  var guidedSetupMenuItems = [solutions, buildItForMe, templates].map(function (viewListItem) {
    return convertToMenuItem(viewListItem);
  });
  return view === View.StartingPoint ? [/*#__PURE__*/React.createElement("div", {
    className: sheetTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 620,
      columnNumber: 9
    },
    key: "0"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionTitle",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 621,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: bolded,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 622,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.startingPoint,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 623,
      columnNumber: 15
    }
  })))), /*#__PURE__*/React.createElement(List, {
    interactive: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 627,
      columnNumber: 9
    },
    key: "1"
  }, startingPointMenuItems.map(function (viewListItem) {
    return /*#__PURE__*/React.createElement(ListItem, {
      listItem: viewListItem,
      pageName: pageName,
      key: "starting-point-list-item-".concat(viewListItem.title),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 629,
        columnNumber: 13
      }
    });
  }))] : view === View.GuidedSetup ? [/*#__PURE__*/React.createElement("button", {
    type: "button",
    className: backButton,
    onClick: function onClick() {
      return setView(View.StartingPoint);
    },
    "aria-label": t(COPY.goBackToStartingPoint),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 638,
      columnNumber: 9
    },
    key: "0"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionTitle",
    color: "dark",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 644,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    className: classNames(sheetTitle, bolded),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 645,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: backButtonIcon,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 650,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(IconChevronLeft, {
    title: "",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 651,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(T, {
    desc: COPY.guidedSetup,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 653,
      columnNumber: 15
    }
  })))), /*#__PURE__*/React.createElement(List, {
    interactive: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 657,
      columnNumber: 9
    },
    key: "1"
  }, guidedSetupMenuItems.map(function (viewListItem) {
    return /*#__PURE__*/React.createElement(ListItem, {
      listItem: viewListItem,
      pageName: pageName,
      key: "guided-setup-list-item-".concat(viewListItem.title),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 659,
        columnNumber: 13
      }
    });
  }))] : null;
};
export var SingleLevelVariant = function SingleLevelVariant(_ref3) {
  var view = _ref3.view,
    pageName = _ref3.pageName;
  var menuItems = [startFromScratchVariant, templatesVariant, buildItForMeVariant, solutionsVariant, buyResponses].map(function (viewListItem) {
    return convertToMenuItem(viewListItem);
  });
  var _useStyles3 = useStyles(),
    sheetTitle = _useStyles3.sheetTitle,
    bolded = _useStyles3.bolded;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: sheetTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 689,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionTitle",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 690,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: bolded,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 691,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.startingPoint,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 692,
      columnNumber: 13
    }
  })))), /*#__PURE__*/React.createElement(List, {
    interactive: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 696,
      columnNumber: 7
    }
  }, menuItems.map(function (viewListItem) {
    return /*#__PURE__*/React.createElement(ListItem, {
      listItem: viewListItem,
      pageName: pageName,
      key: "single-level-list-item-".concat(viewListItem.title),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 698,
        columnNumber: 11
      }
    });
  })));
};
//# sourceMappingURL=ButtonCreateVariants.js.map